var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenLinkDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.8271,
    y1: 496.2232,
    x2: 255.8271,
    y2: 20.2232,
    gradientTransform: "matrix(1.0006 0 0 -1.0006 0.0277 514.3683)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2AF598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009EFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M293.161,349.052h-3.002v-40.023h3.002c27.706,0,55.039-13.283,81.236-39.482l58.101-58.101 c21.821-21.82,35.166-44.358,38.593-65.179c3.615-21.962-3.659-41.67-22.24-60.249c-18.578-18.578-38.289-25.85-60.249-22.24 c-20.718,3.41-43.136,16.641-64.856,38.271l-27.373,30.053l-29.589-26.951l28.339-31.081c27.775-27.774,57.851-44.988,86.979-49.783 c34.614-5.695,67.481,5.861,95.05,33.429c27.569,27.569,39.127,60.435,33.43,95.051c-4.795,29.127-22.009,59.204-49.783,86.979 l-58.101,58.101C368.722,331.824,331.868,349.052,293.161,349.052z M130.269,486.705c29.214-4.81,59.385-22.076,87.244-49.937 l28.436-31.188l-29.589-26.951l-27.471,30.16c-21.806,21.715-44.318,35-65.122,38.425c-22.056,3.632-41.859-3.674-60.52-22.337 c-18.662-18.661-25.968-38.459-22.337-60.52c3.441-20.908,16.841-43.538,38.748-65.444l58.304-58.304 c18.182-18.183,46.014-39.64,76.093-39.64c0.52,0,1.044,0.006,1.564,0.02l6.501-0.02v-40.023l-5.824,0.024 c-35.386-0.803-72.271,16.977-106.634,51.338l-58.305,58.304c-27.861,27.861-45.128,58.03-49.937,87.244 c-5.714,34.713,5.879,67.675,33.527,95.323c23.058,23.057,49.806,34.948,78.189,34.948 C118.787,488.126,124.506,487.655,130.269,486.705z M258.615,297.451l-13.418-14.846c-3.278-3.627-6.62-8.316-10.214-14.329 c-1.039-1.738-2.072-3.804-3.072-6.139l-7.874-18.396l-36.793,15.75l7.875,18.397c1.701,3.974,3.554,7.647,5.508,10.917 c4.955,8.292,9.822,15.041,14.877,20.636l13.418,14.846L258.615,297.451z M171.279,112.267l-58.871-69.574L81.855,68.545 l58.871,69.574L171.279,112.267z M222.121,17.865h-40.023v91.051h40.023V17.865z M430.425,443.454l-58.871-69.574l-30.552,25.853 l58.871,69.574L430.425,443.454z M330.182,403.082H290.16v91.051h40.023V403.082z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkDark);
export default __webpack_public_path__ + "static/media/BrokenLinkDark.6f21b2e7.svg";
export { ForwardRef as ReactComponent };